import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const workInstructionModule = {
  namespaced: true,
  state() {
    return {
      workInstructionPackages: [],
      currentWorkInstructionPackage: null,
      currentWorkInstruction: [],
      jobWorkInstructionStatus: {
        jobId: null,
        hasInstructions: false,
        instructionCount: 0,
        loading: false,
        statusLoaded: false,
      },
    };
  },
  actions,
  getters,
  mutations,
};

export default workInstructionModule;
